import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { ToggleCommentLikePayload } from '@web/newsfeed/types/apiTypes';
import { useArticleCommentsQueryCache } from '@web/newsfeed/Article/ArticleComments/hooks/useArticleCommentsQueryCache';

export const useRemoveCommentLike = () => {
  const { removeCommentLike } = useArticleCommentsQueryCache();
  const { newsfeedComments } = useSlingApi();

  const mutation = useMutation({
    mutationFn: async ({ pageId, articleId, commentId }: ToggleCommentLikePayload) => {
      await newsfeedComments.removeLike(pageId, articleId, commentId);
    },
    onMutate: (payload) => {
      removeCommentLike(payload.articleId, payload.commentId);
    },
  });

  return mutation;
};
